import React from 'react';
export function ComparisonSection() {
  return <section data-id="element-2863">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2864">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2865">
          HEM vs HSM
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2866">
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2867">
          HEM is somewhat similar to an accelerated finishing operation in
          regards to depth of cut, while HSM is more of a high feed contouring
          operation. Both can achieve increased MRR and higher productivity when
          compared to traditional methods. While HSM can be seen as an umbrella
          term for all high efficiency paths, HEM has grown in popularity to a
          point where it can be classified on its own. Classifying each
          separately takes a bit of clarification, showing they each have power
          in certain situations.
        </p>
      </div>
    </section>;
}